import { Component, defineComponent, provide } from 'vue';

import BachelorsFilterContainer from './bachelors/BachelorsFilterContainer.vue';
import DistanceLearningFilterContainer from './distance-learning/DistanceLearningFilterContainer.vue';
import FilterContainer from './FilterContainer.class';
import MastersFilterContainer from './masters/MastersFilterContainer.vue';
import PhdFilterContainer from './phd/PhdFilterContainer.vue';
import ShortCoursesFilterContainer from './short-curses/ShortCoursesFilterContainer.vue';
import FilterProvider from '@/study-search/presentation/components/filters/FilterProvider';
import { FilterProviderKey } from '@studyportals/search-filters';

export default defineComponent({
	components: {
		BachelorsFilterContainer: BachelorsFilterContainer as Component,
		DistanceLearningFilterContainer: DistanceLearningFilterContainer as Component,
		MastersFilterContainer: MastersFilterContainer as Component,
		PhdFilterContainer: PhdFilterContainer as Component,
		ShortCoursesFilterContainer: ShortCoursesFilterContainer as Component
	},
	setup: () => {
		provide(FilterProviderKey.FILTER_PROVIDER, FilterProvider.instance);
		provide(FilterProviderKey.LOCATION_FILTER_PROVIDER, FilterProvider.instance);
		provide(FilterProviderKey.CURRENCY_FILTER_PROVIDER, FilterProvider.instance);

		const component = new FilterContainer();

		return {
			portalType: component.portalType,
			bachelorsValue: component.bachelorsValue,
			distanceLearningValue: component.distanceLearningValue,
			mastersValue: component.mastersValue,
			phdValue: component.phdValue,
			shortCoursesValue: component.shortCoursesValue
		};
	}
});
